var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 29,
    viewBox: "0 0 32 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.65227 3C1.18724 3 0 4.18724 0 5.65227V19.6224C0 21.0874 1.18724 22.2747 2.65227 22.2747H4.86167V28.5569L12.3835 22.2747H26.3467C27.0793 22.2747 27.7426 21.9781 28.222 21.4977C28.3723 21.3474 28.5037 21.1794 28.6155 20.9975C28.6372 20.9609 28.659 20.9243 28.6797 20.8868C28.741 20.7741 28.7944 20.6564 28.8389 20.5348C28.8982 20.3727 28.9427 20.2027 28.9694 20.0267C28.9832 19.9387 28.9921 19.8498 28.996 19.7588C28.998 19.7134 29 19.6679 29 19.6224V5.65227C29 5.6068 28.999 5.56132 28.996 5.51585C28.9911 5.42589 28.9822 5.33594 28.9694 5.24795C28.9357 5.0285 28.8754 4.81794 28.7914 4.61924C28.7578 4.54016 28.7202 4.46305 28.6797 4.38792C28.659 4.35035 28.6382 4.31378 28.6155 4.2772C28.5492 4.16747 28.4751 4.06368 28.394 3.96482C28.2319 3.7681 28.0421 3.5951 27.8305 3.45275C27.4075 3.16706 26.8974 3 26.3477 3H14.4921H2.65227Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 3.5C31.5 5.433 29.933 7 28 7C26.067 7 24.5 5.433 24.5 3.5C24.5 1.567 26.067 0 28 0C29.933 0 31.5 1.567 31.5 3.5Z",
    fill: "#D23333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chatIcon.73059557981ddd83329bd9317389c268.svg";
export { ForwardRef as ReactComponent };